import { z } from 'zod';
import { DEFAULT_SAMPLE_RATE, TRACK_TYPES } from '../constants.js';
// --- Project schemas ---
export const createProjectSchema = z.object({
    name: z.string().min(1).max(200),
    episodeId: z.string().uuid().optional(),
    sampleRate: z.number().int().positive().default(DEFAULT_SAMPLE_RATE),
});
export const updateProjectSchema = createProjectSchema.partial().extend({
    state: z.record(z.unknown()).optional(),
});
// --- Track schemas ---
export const createTrackSchema = z.object({
    name: z.string().min(1).max(200),
    color: z.string().optional().default('#3B82F6'),
    orderIndex: z.number().int().optional(),
    trackType: z.enum(TRACK_TYPES).optional().default('audio'),
});
export const updateTrackSchema = z.object({
    name: z.string().min(1).max(200).optional(),
    volume: z.number().min(0).max(2).optional(),
    pan: z.number().min(-1).max(1).optional(),
    isMuted: z.boolean().optional(),
    isSolo: z.boolean().optional(),
    color: z.string().optional(),
    orderIndex: z.number().int().optional(),
    effectsChain: z.array(z.unknown()).optional(),
    trackType: z.enum(TRACK_TYPES).optional(),
});
export const reorderTracksSchema = z.object({
    trackIds: z.array(z.string().uuid()).min(1),
});
// --- Project export ---
export const AUDIO_EXPORT_FORMATS = ['mp3', 'wav', 'flac', 'ogg', 'aac'];
export const VIDEO_EXPORT_FORMATS = ['mp4', 'webm'];
export const ALL_EXPORT_FORMATS = [
    ...AUDIO_EXPORT_FORMATS,
    ...VIDEO_EXPORT_FORMATS,
];
export const exportProjectSchema = z.object({
    format: z.enum(ALL_EXPORT_FORMATS),
    quality: z.number().min(0).max(10).optional(),
    normalize: z.boolean().default(true),
    resolution: z.enum(['original', '1080p', '720p', '480p']).optional(),
    videoQuality: z.enum(['high', 'medium', 'low']).optional(),
});
//# sourceMappingURL=project.schemas.js.map